<main id="main-content" tabindex="-1" aria-label="Dashboard">
  <div class="mt-10">
    <div class="container mx-auto my-10 md:px-20 px-0 mb-[100px]">
      <div class="h-auto bg-white">
        <section
          #legalNotice
          id="dashboard-legal-notice"
          class="info-margin"
          role="region"
          tabindex="-1"
          aria-labelledby="dashboard-legal-notice-title">

          <h2 id="dashboard-legal-notice-title" class="sr-only">
            Important legal notice
          </h2>

          <p id="dashboard-legal-notice-main">
            <strong>
              "Parents and guardians have a federal constitutional right to be informed if their public school student child expresses
              gender incongruence. Teachers and school staff have a federal constitutional right to accurately inform the parent or
              guardian of their student when the student expresses gender incongruence. These federal constitutional rights are
              superior to any state or local laws, state or local regulations, or state or local policies to the contrary."
            </strong>
          </p>

          <br />

          <p id="dashboard-legal-notice-detail">
            Publication of this statement was compelled by the Order Granting Plaintiffs' Motion for Class-Wide Permanent Injunction
            issued by U.S. District Court for the Southern District of California in
            <span style="font-style: italic;">Mirabelli v. Olson</span>, No: 3-23-cv-00768. The U.S.
            Supreme Court has allowed a stay of that injunction with respect to public school employee plaintiffs to remain in
            effect until the case is resolved on appeal in the U.S. Court of Appeals for the Ninth Circuit. The full statement
            required under the injunction is posted here until the district court provides further clarification otherwise.
          </p>
        </section>

        <section
          id="courses-history-section"
          role="region"
          tabindex="-1"
          aria-labelledby="courses-history-title">

          <prism-title
            id="courses-history-title"
            additionalClasses="text-4xl"
            title="Courses History">
          </prism-title>

          <prism-accordion
            [items]="accordionPanels"
            [expandedIconClass]="'uil-angle-down'"
            [collapsedIconClass]="'uil-angle-up'"
            [iconSizeClass]="'text-3xl'"
            [showClickToExpandHint]="true">

            <ng-template #accordionHeader let-panel>
              @if (panel.isModulesPanel) {
                <span class="font-semibold">{{ panel.label }}</span>
              } @else {
                <span class="font-semibold">{{ panel.schoolYear.name }}</span>

                <span
                  *ngIf="panel.schoolYear.isCurrent"
                  class="ml-2 text-sm font-semibold text-dark-purple">
                  (Current)
                </span>
              }
            </ng-template>

            <ng-template #accordionBody let-panel>
              @if (panel.isModulesPanel) {
                @if (modulesCourses.length === 0) {
                  <p class="m-0 text-dark-purple">
                    No modules courses available.
                  </p>
                }
                @else {
                  <prism-module-card-list
                    [courses]="modulesCourses"
                    (courseClick)="viewModulesCourse($event)">
                  </prism-module-card-list>
                }
              } @else {
                @if (panel.courses.length === 0) {
                  <p class="m-0 text-dark-purple">
                    No course attempted for this school year. Please go to Courses at the top of the page to select a course.
                  </p>
                }
                @else {
                  <prism-card-list
                    [dataList]="mapUserCoursesToCards(panel.courses)"
                    (cardClick)="viewCourse($event)">
                  </prism-card-list>
                }
              }
            </ng-template>
          </prism-accordion>

        </section>
      </div>
    </div>
  </div>
</main>